import React from "react";
import { createPortal } from "react-dom";
import IconButton from "./IconButton";
import PropTypes from "prop-types";

const Modal = ({
  isOpen,
  onClose,
  children,
  showCloseIcon,
  className = "",
  component,
  closeIcon = (
    <svg
      width={component === "leaderboard" ? "20" : "14"}
      height={component === "leaderboard" ? "20" : "14"}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 1L1 13M1 1L13 13"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  title,
}) => {
  if (!isOpen) return null;
  const onClickXMark = (event) => {
    if (onClose) onClose(event);
  };

  return createPortal(
    <div className={`modalContainer ${className}`} onClick={onClickXMark}>
      <div
        className={
          component === "leaderboard"
            ? "modalContent_leaderboard"
            : "modalContent"
        }
        onClick={(event) => event.stopPropagation()}
      >
        {(title || showCloseIcon) && (
          <div className="modalTitleAnyOne">
            {title && <div className="modalTitle">{title}</div>}
            {showCloseIcon && (
              <div className="modalCloseIcon">
                <IconButton
                  onClick={onClickXMark}
                  size="sm"
                  hierarchy="tertiaryGrey"
                >
                  {closeIcon}
                </IconButton>
              </div>
            )}
          </div>
        )}
        {children}
      </div>
    </div>,
    document.body,
  );
};

export default Modal;

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  showCloseIcon: PropTypes.bool,
};

Modal.defaultProps = {
  isOpen: false,
  children: null,
  showCloseIcon: true,
};
